import { Component } from 'src/utils';
import template from './subscription-modify.html';
import resetPwdImg from './../../../images/reset-pass-2.png';
import confirmImg from './../../../images/tick-sent.png';


@Component({
  controllerAs: 'subscriptionModify',
  template
})

export default class ActivateContainer {
  static $inject = [
    '$scope',
    '$stateParams',
    '$ngRedux',
    'authActions',
    'authService',
    '$state'
  ];

  constructor($scope, $stateParams, $ngRedux, authActions, authService,$state) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$ngRedux = $ngRedux;
    this.$stateParams = $stateParams;
    this.authActions = authActions;
    this.authService = authService;
    this.resetPwdImg = resetPwdImg;
    this.confirmImg = confirmImg;
    this.storeName = $stateParams.storeName;
    this.$state = $state;
    this.activate();

    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      auth: state.auth
    };
  }

  activate() {
    this.authService.modifySubscripitonfromEmail({
      token: this.$stateParams.token

    })
      .then(
        success => {
          // console.log(success);
          var tokensubstring =  this.$stateParams.token.split('_')[1].substring(1);
          this.authService.subscriptionmodifyId({'id':tokensubstring.substring(0, tokensubstring.length - 1)});
          this.$state.go('login',{storeName:this.$stateParams.storeName});

        })
      .catch(err => {
        //  console.log(err);
        if (err.data.errorCode === 624 ) {
          this.alreadyUser = 'The Subscripiton Cycle is expired';
        }
        else {
          this.activationerror = err.data.message;
        }
      });
  }

  submit(form) {
    if (form.$invalid) {
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/subscription-modify/subscription-modify.js